<template>
  <button-line
    :items="[
      {
        label: $ucfirst($t('journeyProgress.progress')),
        route: {
          name: 'PatientRecordKnowledgeProgress',
          params: { patientId },
        },
        disabled: version < 3
      },
      {
        label: $ucfirst($t('timeline')),
        route: {
          name: 'PatientRecordKnowledgeTimeline',
          params: { patientId },
        },
        disabled: version < 3
      },
      {
        label: $ucfirst($t('knowledge.selection')),
        route: {
          name: 'PatientRecordKnowledgeSelection',
          params: { patientId },
        },
      },
    ]"
    v-bind="$attrs"
  />
</template>

<script>
import ButtonLine from "./ButtonLine";
import { mapGetters } from 'vuex';

/**
 * Component KnowledgeButtonLine.vue
 *
 * @module KnowledgeButtonLine
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.8] app/src/APP_DASHBOARD/templates/components/Parts/KnowledgeButtonLine.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "KnowledgeButtonLine",
  components: {
    ButtonLine,
  },
  computed: {
    ...mapGetters({
      patientId: 'patientSummary/id',
      version: 'patientSummary/currentVersion'
    }),
  },
};
</script>

<style lang="scss">
</style>
